export default {
  zh: {
    rechargeRecords: '充值记录',
    noRechargeRecords: '您还没有充值记录',
    time: '时间',
    memberType: '会员类型',
    item: '套餐',
    amount: '金额',
    status: '状态',
    paymentMethods: '支付方式',
    devices: '台设备',
    pending: '未处理',
    cancelled: '已退款',
    closed: '关闭',
    paying: '处理中',
    paid: '充值成功',
    wechatpay: '微信支付',
    alipay_global: '支付宝支付',
    ':': '：',
    invoice: '发票',
    is_loading: '正在加载...'
  },
  en: {
    rechargeRecords: 'Purchase Records',
    noRechargeRecords: "No Purchase Records",
    time: 'Time',
    memberType: 'Member Type',
    item: 'Plan',
    amount: 'Amount',
    status: 'Status',
    paymentMethods: 'Payment Method',
    devices: 'device | devices',
    pending: 'Pending',
    cancelled: 'Refunded',
    closed: 'Closed',
    paying: 'Paying',
    paid: 'Paid',
    wechatpay: 'WeChat Pay',
    alipay_global: 'Alipay',
    ':': '：',
    invoice: 'Invoice',
    is_loading: 'Loading...'
  }
}



// WEBPACK FOOTER //
// ./src/components/rechargeRecord/lang.js